import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from 'app/auth/auth.guard';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatIconModule } from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {MatDividerModule} from '@angular/material/divider';

import { FuseSharedModule } from '@fuse/shared.module';
import { LogActualizacionesComponent } from './log-actualizaciones.component';

const rutas: Routes = [
    {
        path     : 'changelog',
        component: LogActualizacionesComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
  declarations: [
    LogActualizacionesComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    TranslateModule,
    FlexLayoutModule,
    MatIconModule,
    FuseSharedModule,
    MatChipsModule,
    MatDividerModule
  ]
})
export class LogActualizacionesModule { }
